export default "__VITE_ASSET__CxyaSugP__"